<template>
  <div data-cy="attributeSelectorDropdown">
    <v-autocomplete
      :items="attributeListShowable"
      :label="`Select additional ${entityName} attributes to view`"
      :value="attributeListSelected"
      @change="updateAttributeListSelected"
      chips
      class="mt-3"
      deletable-chips
      item-text="label"
      item-value="name"
      multiple
      outlined
      return-object
      style="margin-bottom: -30px"
    ></v-autocomplete>
  </div>
</template>

<script>
export default {
  methods: {
    updateAttributeListSelected(updatedAttributeListSelected) {
      this.$emit(
        "update-attribute-list-selected",
        updatedAttributeListSelected
      );
    },
  },
  props: {
    attributeListShowable: {
      required: true,
      type: Array,
    },
    attributeListSelected: {
      required: true,
      type: Array,
    },
    entityName: {
      required: true,
      type: String,
    },
  },
};
</script>
